// extracted by mini-css-extract-plugin
export var completionBody = "_dp-2";
export var completionCard = "_dp-0";
export var completionFooter = "_dp-3";
export var completionTitle = "_dp-1";